<template>
  <div
    id="enterprise-add"
    class="
      h-screen
      flex flex-col
      justify-between
      w-full
      bg-img
      no-gutter
      items-center
    "
  >
    <titlebar>
      <template v-slot:invitesWizard>
        <invites-wizard
          ref="invitesWizard"
          :wizardStartIndex="wizardStartIndex"
          :wizardStepShape="wizardStepShape"
        />
      </template>
    </titlebar>
    <enterprise-add-form
      :handleSuccessCreateEnterprise="handleSuccessCreateEnterprise"
    />
    <invites-footer />
  </div>
</template>

<script>
import Titlebar from "./components/Titlebar.vue";
import InvitesWizard from "./components/InvitesWizard.vue";
import InvitesFooter from "./components/InvitesFooter.vue";
import EnterpriseAddForm from "./components/EnterpriseAddForm.vue";

export default {
  name: "EnterpriseAdd",
  mixins: [],
  props: {
    wizardStartIndex: { type: Number, default: 1 },
    wizardStepShape: { type: String, default: "square" },
  },
  components: {
    Titlebar,
    InvitesWizard,
    InvitesFooter,
    EnterpriseAddForm,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleSuccessCreateEnterprise() {
      this.$refs.invitesWizard.nextTab();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#enterprise-add {
  background-image: unset;
  background-color: #f6f9fa;
  --vs-primary: 3, 155, 229;
}
</style>
